var _circle, _circle2, _circle3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    transform: "rotate(90 20 20)",
    fill: "#171F36"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    transform: "rotate(90 20 20)",
    stroke: "#8A8CB2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    transform: "rotate(90 20 20)",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 12C19.4478 12 19.0001 12.4478 19.0001 13V19H13.0001C12.4478 19 12.0001 19.4478 12.0001 20C12.0001 20.5523 12.4478 21 13.0001 21H19.0001V27C19.0001 27.5523 19.4478 28 20.0001 28C20.5523 28 21.0001 27.5523 21.0001 27V21H27.0001C27.5523 21 28.0001 20.5523 28.0001 20C28.0001 19.4478 27.5523 19 27.0001 19H21.0001V13C21.0001 12.4478 20.5523 12 20.0001 12Z",
    fill: "#8A8CB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 12C19.4478 12 19.0001 12.4478 19.0001 13V19H13.0001C12.4478 19 12.0001 19.4478 12.0001 20C12.0001 20.5523 12.4478 21 13.0001 21H19.0001V27C19.0001 27.5523 19.4478 28 20.0001 28C20.5523 28 21.0001 27.5523 21.0001 27V21H27.0001C27.5523 21 28.0001 20.5523 28.0001 20C28.0001 19.4478 27.5523 19 27.0001 19H21.0001V13C21.0001 12.4478 20.5523 12 20.0001 12Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommon);
export default __webpack_public_path__ + "static/media/common.69002b260b9e219773ad8f6983a42e3f.svg";
export { ForwardRef as ReactComponent };